import React, { FC } from 'react'
import { css } from '@emotion/react'
import { Trans } from '@lingui/macro'

import Loader from '../../../../../components/common/loader/Loader'
import UserDetail from '../../../../../components/common/user/user-detail/UserDetail'
import { useFreeQuizResultsBreakdownQuery } from './FreeQuizAnswersBreakdown.codegen'

import '../quizResults/QuizResults.less'
import { formatDateAndTimeLong } from 'front-end/src/utils/dateHelpers'
import { Box } from 'front-end/src/components'
import { fonts } from 'front-end/src/components/chakraThemeExtension'

export const FreeQuizAnswersBreakdown: FC<{
  topicId: number
  interval: {
    from: string
    to: string
  }
  groupIds: number[] | null
  elementId: number
}> = (props) => {
  const { data, loading } = useFreeQuizResultsBreakdownQuery({
    variables: props
  })
  if (loading) {
    return <Loader />
  }

  const {
    topic: { lastTopicVersion }
  } = data

  if (
    !lastTopicVersion ||
    !lastTopicVersion.publishedElement ||
    !lastTopicVersion.publishedElement.freeTextResponses.length
  ) {
    return (
      <div className="workbook-quizzes">
        <p className="AnalyticsPage__no-data">
          <Trans>No data available</Trans>
        </p>
      </div>
    )
  }

  const freeQuizResponses = lastTopicVersion.publishedElement.freeTextResponses

  return (
    <table
      css={css`
        margin: 16px 0;
        font-size: 15px;
        line-height: 20px;
      `}
    >
      <thead>
        <tr>
          <th>
            <Trans>Name</Trans>
          </th>
          <th>
            <Trans>Date</Trans>{' '}
          </th>
          <th>
            <Trans>Answer</Trans>
          </th>
        </tr>
      </thead>
      <tbody>
        {freeQuizResponses.map((entry) => {
          return (
            <tr key={entry.id}>
              <td>
                <UserDetail
                  display_name={entry.enrolment.user.display_name}
                  imageUrl={entry.enrolment.user.image_url}
                  meta={entry.enrolment.user.userIdentity}
                  size={'normal'}
                />
              </td>
              <td>{formatDateAndTimeLong(entry?.created_at)}</td>
              <td>
                <Box as="pre" my={0} fontFamily={fonts.body}>
                  {entry.freeQuizResponse}
                </Box>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
